import { memo } from 'react';

import IconFile from '@/assets/Icons/IconFile.tsx';
import IconPrinter from '@/assets/Icons/IconPrinter.tsx';
import { eExportFormat } from '@/components/organism/DataTable/model.ts';

export interface IExportButtonProps {
  onClick: (format: eExportFormat) => void;
  format: eExportFormat;
  inDropdown?: boolean;
}

export const ExportButton = memo(({ format, onClick, inDropdown }: IExportButtonProps) => {
  if (inDropdown) {
    return (
      <button
        type='button'
        className='flex w-full cursor-pointer items-center gap-2 border-none bg-transparent py-2 text-left text-black dark:!text-white'
        onClick={() => onClick(format)}
      >
        {format !== eExportFormat.PRINT ? (
          <IconFile className='text-white-light h-4 w-4' />
        ) : (
          <IconPrinter className='text-white-light h-4 w-4' />
        )}
        <span>{format}</span>
      </button>
    );
  }

  return (
    <button
      type='button'
      className='dark:bg-c16 flex h-12 items-center gap-2 rounded-md border border-[rgb(224,230,237)] bg-white px-4 py-3 text-sm hover:border-inherit dark:border-white'
      onClick={() => onClick(format)}
    >
      {format !== eExportFormat.PRINT ? (
        <IconFile className='h-4 w-4' />
      ) : (
        <IconPrinter className='h-4 w-4' />
      )}
      {format}
    </button>
  );
});
